/**
 * useFriendConfig — reads the global friend-system switches once (module-cached)
 * so every friend surface (header menu, dashboard rail, /friends, chat, talk,
 * suggestions, group play) can gate itself. Admin changes take effect on reload.
 */
import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const DEFAULTS = {
  friends_enabled: true, chat_enabled: true, walkie_talkie_enabled: true,
  suggestions_enabled: true, group_play_enabled: true, max_group_players: 4,
  avatar_system_enabled: false, parent_approval_required: false, presence_enabled: true,
};

let _cache = null;
let _promise = null;

export function loadFriendConfig(force = false) {
  if (_cache && !force) return Promise.resolve(_cache);
  if (_promise && !force) return _promise;
  _promise = axios.get(`${API}/api/friends/config`)
    .then((r) => { _cache = { ...DEFAULTS, ...(r.data?.config || {}) }; return _cache; })
    .catch(() => { _cache = { ...DEFAULTS }; return _cache; })
    .finally(() => { _promise = null; });
  return _promise;
}

export function useFriendConfig() {
  const [config, setConfig] = useState(_cache || DEFAULTS);
  const [loading, setLoading] = useState(!_cache);
  useEffect(() => {
    let alive = true;
    loadFriendConfig().then((c) => { if (alive) { setConfig(c); setLoading(false); } });
    return () => { alive = false; };
  }, []);
  return { config, loading };
}

export default useFriendConfig;
